"use strict";

var _toConsumableArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Config = exports.StyleguideConfig = exports.AVAILABLE_REGIONS = exports.DOMAINS = exports.DEFAULT_REGION = exports.IGNORE_FILE = void 0;

var fs = require("fs");

var path = require("path");

var js_yaml_1 = require("../js-yaml");

var utils_1 = require("../utils");

var oas_types_1 = require("../oas-types");

var env_1 = require("../env");

var utils_2 = require("./utils");

exports.IGNORE_FILE = '.redocly.lint-ignore.yaml';
var IGNORE_BANNER = "# This file instructs Redocly's linter to ignore the rules contained for specific parts of your API.\n" + "# See https://redoc.ly/docs/cli/ for more information.\n";
exports.DEFAULT_REGION = 'us';

function getDomains() {
  var domains = {
    us: 'redocly.com',
    eu: 'eu.redocly.com'
  }; // FIXME: temporary fix for our lab environments

  var domain = env_1.env.REDOCLY_DOMAIN;

  if (domain === null || domain === void 0 ? void 0 : domain.endsWith('.redocly.host')) {
    domains[domain.split('.')[0]] = domain;
  }

  if (domain === 'redoc.online') {
    domains[domain] = domain;
  }

  return domains;
}

function getIgnoreFilePath(configFile) {
  if (configFile) {
    return utils_1.doesYamlFileExist(configFile) ? path.join(path.dirname(configFile), exports.IGNORE_FILE) : path.join(configFile, exports.IGNORE_FILE);
  } else {
    return typeof process === 'undefined' ? undefined : path.join(process.cwd(), exports.IGNORE_FILE);
  }
}

exports.DOMAINS = getDomains();
exports.AVAILABLE_REGIONS = Object.keys(exports.DOMAINS);

var StyleguideConfig = /*#__PURE__*/function () {
  function StyleguideConfig(rawConfig, configFile) {
    var _this$rules, _this$preprocessors, _this$decorators;

    _classCallCheck(this, StyleguideConfig);

    this.rawConfig = rawConfig;
    this.configFile = configFile;
    this.ignore = {};
    this._usedRules = new Set();
    this._usedVersions = new Set();
    this.plugins = rawConfig.plugins || [];
    this.doNotResolveExamples = !!rawConfig.doNotResolveExamples;
    this.recommendedFallback = rawConfig.recommendedFallback || false;
    this.rules = (_this$rules = {}, _defineProperty(_this$rules, oas_types_1.OasVersion.Version2, Object.assign(Object.assign({}, rawConfig.rules), rawConfig.oas2Rules)), _defineProperty(_this$rules, oas_types_1.OasVersion.Version3_0, Object.assign(Object.assign({}, rawConfig.rules), rawConfig.oas3_0Rules)), _defineProperty(_this$rules, oas_types_1.OasVersion.Version3_1, Object.assign(Object.assign({}, rawConfig.rules), rawConfig.oas3_1Rules)), _this$rules);
    this.preprocessors = (_this$preprocessors = {}, _defineProperty(_this$preprocessors, oas_types_1.OasVersion.Version2, Object.assign(Object.assign({}, rawConfig.preprocessors), rawConfig.oas2Preprocessors)), _defineProperty(_this$preprocessors, oas_types_1.OasVersion.Version3_0, Object.assign(Object.assign({}, rawConfig.preprocessors), rawConfig.oas3_0Preprocessors)), _defineProperty(_this$preprocessors, oas_types_1.OasVersion.Version3_1, Object.assign(Object.assign({}, rawConfig.preprocessors), rawConfig.oas3_1Preprocessors)), _this$preprocessors);
    this.decorators = (_this$decorators = {}, _defineProperty(_this$decorators, oas_types_1.OasVersion.Version2, Object.assign(Object.assign({}, rawConfig.decorators), rawConfig.oas2Decorators)), _defineProperty(_this$decorators, oas_types_1.OasVersion.Version3_0, Object.assign(Object.assign({}, rawConfig.decorators), rawConfig.oas3_0Decorators)), _defineProperty(_this$decorators, oas_types_1.OasVersion.Version3_1, Object.assign(Object.assign({}, rawConfig.decorators), rawConfig.oas3_1Decorators)), _this$decorators);
    this.extendPaths = rawConfig.extendPaths || [];
    this.pluginPaths = rawConfig.pluginPaths || [];
    this.resolveIgnore(getIgnoreFilePath(configFile));
  }

  _createClass(StyleguideConfig, [{
    key: "resolveIgnore",
    value: function resolveIgnore(ignoreFile) {
      if (!ignoreFile || !utils_1.doesYamlFileExist(ignoreFile)) return;
      this.ignore = js_yaml_1.parseYaml(fs.readFileSync(ignoreFile, 'utf-8')) || {}; // resolve ignore paths

      for (var _i = 0, _Object$keys = Object.keys(this.ignore); _i < _Object$keys.length; _i++) {
        var fileName = _Object$keys[_i];
        this.ignore[path.resolve(path.dirname(ignoreFile), fileName)] = this.ignore[fileName];

        for (var _i2 = 0, _Object$keys2 = Object.keys(this.ignore[fileName]); _i2 < _Object$keys2.length; _i2++) {
          var ruleId = _Object$keys2[_i2];
          this.ignore[fileName][ruleId] = new Set(this.ignore[fileName][ruleId]);
        }

        delete this.ignore[fileName];
      }
    }
  }, {
    key: "saveIgnore",
    value: function saveIgnore() {
      var dir = this.configFile ? path.dirname(this.configFile) : process.cwd();
      var ignoreFile = path.join(dir, exports.IGNORE_FILE);
      var mapped = {};

      for (var _i3 = 0, _Object$keys3 = Object.keys(this.ignore); _i3 < _Object$keys3.length; _i3++) {
        var absFileName = _Object$keys3[_i3];
        var ignoredRules = mapped[utils_1.slash(path.relative(dir, absFileName))] = this.ignore[absFileName];

        for (var _i4 = 0, _Object$keys4 = Object.keys(ignoredRules); _i4 < _Object$keys4.length; _i4++) {
          var ruleId = _Object$keys4[_i4];
          ignoredRules[ruleId] = Array.from(ignoredRules[ruleId]);
        }
      }

      fs.writeFileSync(ignoreFile, IGNORE_BANNER + js_yaml_1.stringifyYaml(mapped));
    }
  }, {
    key: "addIgnore",
    value: function addIgnore(problem) {
      var ignore = this.ignore;
      var loc = problem.location[0];
      if (loc.pointer === undefined) return;
      var fileIgnore = ignore[loc.source.absoluteRef] = ignore[loc.source.absoluteRef] || {};
      var ruleIgnore = fileIgnore[problem.ruleId] = fileIgnore[problem.ruleId] || new Set();
      ruleIgnore.add(loc.pointer);
    }
  }, {
    key: "addProblemToIgnore",
    value: function addProblemToIgnore(problem) {
      var loc = problem.location[0];
      if (loc.pointer === undefined) return problem;
      var fileIgnore = this.ignore[loc.source.absoluteRef] || {};
      var ruleIgnore = fileIgnore[problem.ruleId];
      var ignored = ruleIgnore && ruleIgnore.has(loc.pointer);
      return ignored ? Object.assign(Object.assign({}, problem), {
        ignored: ignored
      }) : problem;
    }
  }, {
    key: "extendTypes",
    value: function extendTypes(types, version) {
      var extendedTypes = types;

      var _iterator = _createForOfIteratorHelper(this.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;

          if (plugin.typeExtension !== undefined) {
            switch (version) {
              case oas_types_1.OasVersion.Version3_0:
              case oas_types_1.OasVersion.Version3_1:
                if (!plugin.typeExtension.oas3) continue;
                extendedTypes = plugin.typeExtension.oas3(extendedTypes, version);
                break;

              case oas_types_1.OasVersion.Version2:
                if (!plugin.typeExtension.oas2) continue;
                extendedTypes = plugin.typeExtension.oas2(extendedTypes, version);
                break;

              default:
                throw new Error('Not implemented');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return extendedTypes;
    }
  }, {
    key: "getRuleSettings",
    value: function getRuleSettings(ruleId, oasVersion) {
      this._usedRules.add(ruleId);

      this._usedVersions.add(oasVersion);

      var settings = this.rules[oasVersion][ruleId] || 'off';

      if (typeof settings === 'string') {
        return {
          severity: settings
        };
      } else {
        return Object.assign({
          severity: 'error'
        }, settings);
      }
    }
  }, {
    key: "getPreprocessorSettings",
    value: function getPreprocessorSettings(ruleId, oasVersion) {
      this._usedRules.add(ruleId);

      this._usedVersions.add(oasVersion);

      var settings = this.preprocessors[oasVersion][ruleId] || 'off';

      if (typeof settings === 'string') {
        return {
          severity: settings === 'on' ? 'error' : settings
        };
      } else {
        return Object.assign({
          severity: 'error'
        }, settings);
      }
    }
  }, {
    key: "getDecoratorSettings",
    value: function getDecoratorSettings(ruleId, oasVersion) {
      this._usedRules.add(ruleId);

      this._usedVersions.add(oasVersion);

      var settings = this.decorators[oasVersion][ruleId] || 'off';

      if (typeof settings === 'string') {
        return {
          severity: settings === 'on' ? 'error' : settings
        };
      } else {
        return Object.assign({
          severity: 'error'
        }, settings);
      }
    }
  }, {
    key: "getUnusedRules",
    value: function getUnusedRules() {
      var _this = this;

      var rules = [];
      var decorators = [];
      var preprocessors = [];

      for (var _i5 = 0, _Array$from = Array.from(this._usedVersions); _i5 < _Array$from.length; _i5++) {
        var usedVersion = _Array$from[_i5];
        rules.push.apply(rules, _toConsumableArray(Object.keys(this.rules[usedVersion]).filter(function (name) {
          return !_this._usedRules.has(name);
        })));
        decorators.push.apply(decorators, _toConsumableArray(Object.keys(this.decorators[usedVersion]).filter(function (name) {
          return !_this._usedRules.has(name);
        })));
        preprocessors.push.apply(preprocessors, _toConsumableArray(Object.keys(this.preprocessors[usedVersion]).filter(function (name) {
          return !_this._usedRules.has(name);
        })));
      }

      return {
        rules: rules,
        preprocessors: preprocessors,
        decorators: decorators
      };
    }
  }, {
    key: "getRulesForOasVersion",
    value: function getRulesForOasVersion(version) {
      switch (version) {
        case oas_types_1.OasMajorVersion.Version3:
          // eslint-disable-next-line no-case-declarations
          var oas3Rules = []; // default ruleset

          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.preprocessors) === null || _a === void 0 ? void 0 : _a.oas3) && oas3Rules.push(p.preprocessors.oas3);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.rules) === null || _a === void 0 ? void 0 : _a.oas3) && oas3Rules.push(p.rules.oas3);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.decorators) === null || _a === void 0 ? void 0 : _a.oas3) && oas3Rules.push(p.decorators.oas3);
          });
          return oas3Rules;

        case oas_types_1.OasMajorVersion.Version2:
          // eslint-disable-next-line no-case-declarations
          var oas2Rules = []; // default ruleset

          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.preprocessors) === null || _a === void 0 ? void 0 : _a.oas2) && oas2Rules.push(p.preprocessors.oas2);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.rules) === null || _a === void 0 ? void 0 : _a.oas2) && oas2Rules.push(p.rules.oas2);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.decorators) === null || _a === void 0 ? void 0 : _a.oas2) && oas2Rules.push(p.decorators.oas2);
          });
          return oas2Rules;
      }
    }
  }, {
    key: "skipRules",
    value: function skipRules(rules) {
      var _iterator2 = _createForOfIteratorHelper(rules || []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ruleId = _step2.value;

          for (var _i6 = 0, _Object$values = Object.values(oas_types_1.OasVersion); _i6 < _Object$values.length; _i6++) {
            var version = _Object$values[_i6];

            if (this.rules[version][ruleId]) {
              this.rules[version][ruleId] = 'off';
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "skipPreprocessors",
    value: function skipPreprocessors(preprocessors) {
      var _iterator3 = _createForOfIteratorHelper(preprocessors || []),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var preprocessorId = _step3.value;

          for (var _i7 = 0, _Object$values2 = Object.values(oas_types_1.OasVersion); _i7 < _Object$values2.length; _i7++) {
            var version = _Object$values2[_i7];

            if (this.preprocessors[version][preprocessorId]) {
              this.preprocessors[version][preprocessorId] = 'off';
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "skipDecorators",
    value: function skipDecorators(decorators) {
      var _iterator4 = _createForOfIteratorHelper(decorators || []),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var decoratorId = _step4.value;

          for (var _i8 = 0, _Object$values3 = Object.values(oas_types_1.OasVersion); _i8 < _Object$values3.length; _i8++) {
            var version = _Object$values3[_i8];

            if (this.decorators[version][decoratorId]) {
              this.decorators[version][decoratorId] = 'off';
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }]);

  return StyleguideConfig;
}();

exports.StyleguideConfig = StyleguideConfig;

var Config = /*#__PURE__*/_createClass(function Config(rawConfig, configFile) {
  _classCallCheck(this, Config);

  this.rawConfig = rawConfig;
  this.configFile = configFile;
  this.apis = rawConfig.apis || {};
  this.styleguide = new StyleguideConfig(rawConfig.styleguide || {}, configFile);
  this['features.openapi'] = rawConfig['features.openapi'] || {};
  this['features.mockServer'] = rawConfig['features.mockServer'] || {};
  this.resolve = utils_2.getResolveConfig(rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.resolve);
  this.region = rawConfig.region;
  this.organization = rawConfig.organization;
  this.files = rawConfig.files || [];
});

exports.Config = Config;